module.exports = __webpack_public_path__ + "img/terminal.e2c3dc6b.png";